// extracted by mini-css-extract-plugin
export default {"icon":"FullscreenBtn_icon__TmqcH"};